import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-5,1h1v0.5h-1zM3,1h3v0.5h-3zM-6,1.5h3v0.5h-3zM3.5,1.5h3.5v0.5h-3.5zM-5,2h2.5v0.5h-2.5zM3,2h3v0.5h-3zM-2,2.5h0.5v0.5h-0.5zM2,2.5h1v0.5h-1z',
    },
    {
      paint: 'rock',
      d: 'M0,-13.5h3.5v0.5h-3.5zM-3,-13h5v0.5h-5zM2.5,-13h0.5v0.5h-0.5zM-3,-12.5h2v0.5h-2zM-8,-8.5h0.5v0.5h-0.5zM7.5,-8.5h0.5v0.5h-0.5zM-8,-8h1.5v0.5h-1.5zM6.5,-8h1.5v0.5h-1.5zM-6.5,-7.5h1v0.5h-1zM5.5,-7.5h1v0.5h-1zM-5,-7h1v0.5h-1zM4,-7h0.5v0.5h-0.5zM-4,-6.5h1.5v0.5h-1.5zM2.5,-6.5h1v0.5h-1zM-2,-6h1v0.5h-1zM1,-6h1v0.5h-1zM-0.5,-5.5h1v0.5h-1zM-5.5,-1h1.5v0.5h-1.5zM4,-1h1.5v0.5h-1.5zM-5,-0.5h2v0.5h-2zM3,-0.5h2.5v0.5h-2.5zM-4,0h2v0.5h-2zM2,0h2.5v0.5h-2.5zM-3,0.5h2v0.5h-2zM1.5,0.5h2v0.5h-2zM-2.5,1h2v0.5h-2zM2.5,1h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'boulder',
      d: 'M-6,-1h0.5v0.5h-0.5zM-6,-0.5h1v0.5h-1zM-6,0h2v0.5h-2zM-5,0.5h2v0.5h-2zM-4,1h1.5v0.5h-1.5zM-3,1.5h1.5v0.5h-1.5zM3,1.5h0.5v0.5h-0.5zM-2.5,2h2v0.5h-2zM2.5,2h0.5v0.5h-0.5zM-1.5,2.5h2v0.5h-2zM-0.5,3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-5,-6h0.5v2h-0.5zM-1,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM-2,-3.5h2v0.5h-2zM0.5,-3.5h1.5v0.5h-1.5zM-5,-3h0.5v2h-0.5zM-3,-3h3v0.5h-3zM0.5,-3h2.5v0.5h-2.5zM-4,-2.5h0.5v2h-0.5zM-2,-2.5h2v0.5h-2zM0.5,-2.5h1.5v0.5h-1.5zM3.5,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM-1,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM2,-2h1v2h-1zM3.5,-2h1v0.5h-1zM-2.5,-1.5h0.5v0.5h-0.5zM3.5,-1.5h1.5v0.5h-1.5zM-3,-1h1v1h-1zM-1,-1h0.5v0.5h-0.5zM0.5,-1h1v1h-1zM3.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h1.5v0.5h-1.5zM-2,0h2v0.5h-2zM0.5,0h1.5v0.5h-1.5zM-1,0.5h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M4,-6h1v2.5h-1zM-0.5,-4.5h1v1h-1zM-5,-4h0.5v0.5h-0.5zM-5,-3.5h1.5v0.5h-1.5zM0,-3.5h0.5v2h-0.5zM3.5,-3.5h1.5v0.5h-1.5zM-4,-3h1v0.5h-1zM3,-3h2v0.5h-2zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM4,-2.5h1v0.5h-1zM-3.5,-2h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM3,-2h0.5v1.5h-0.5zM4.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-2,-1.5h4v0.5h-4zM-3.5,-1h0.5v0.5h-0.5zM-2,-1h1v0.5h-1zM-0.5,-1h1v0.5h-1zM1.5,-1h0.5v1h-0.5zM-2,-0.5h0.5v0.5h-0.5zM0,-0.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4.5,-6h0.5v2.5h-0.5zM-4.5,-3h0.5v1.5h-0.5z',
    },
    {
      paint: 'path',
      d: 'M0.5,1h2v0.5h-2zM-0.5,1.5h3.5v0.5h-3.5zM-0.5,2h3v0.5h-3zM0.5,2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8,-7.5h1.5v0.5h-1.5zM6.5,-7.5h1.5v0.5h-1.5zM-7,-7h2v0.5h-2zM5,-7h2v0.5h-2zM-5.5,-6.5h1.5v0.5h-1.5zM3.5,-6.5h2v0.5h-2zM-4,-6h2v0.5h-2zM2,-6h2v0.5h-2zM-2.5,-5.5h2v0.5h-2zM0.5,-5.5h2v0.5h-2zM-1,-5h2v0.5h-2z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M2,-13h0.5v0.5h-0.5zM-1,-12.5h3v0.5h-3zM-2.5,-12h4.5v1h-4.5zM-3,-11h4.5v1h-4.5zM-4,-10h2.5v0.5h-2.5zM-1,-10h2.5v0.5h-2.5zM-5,-9.5h6v0.5h-6zM5,-9.5h0.5v0.5h-0.5zM-5.5,-9h6.5v0.5h-6.5zM-7,-8.5h8v0.5h-8zM7,-8.5h0.5v0.5h-0.5zM-6.5,-8h7v0.5h-7zM-5.5,-7.5h6v0.5h-6zM5,-7.5h0.5v0.5h-0.5zM-4,-7h4.5v0.5h-4.5zM3.5,-7h0.5v0.5h-0.5zM4.5,-7h0.5v0.5h-0.5zM-2.5,-6.5h2.5v0.5h-2.5zM2,-6.5h0.5v0.5h-0.5zM-1,-6h1v0.5h-1zM0.5,-6h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2,-12.5h1v1h-1zM-3,-11.5h0.5v0.5h-0.5zM2,-11.5h1.5v0.5h-1.5zM-3.5,-11h0.5v1h-0.5zM1.5,-11h2.5v1h-2.5zM-1.5,-10h0.5v0.5h-0.5zM1.5,-10h3v0.5h-3zM1,-9.5h4v0.5h-4zM1,-9h5v0.5h-5zM1,-8.5h6v0.5h-6zM0.5,-8h6v0.5h-6zM0.5,-7.5h4.5v0.5h-4.5zM0.5,-7h3v0.5h-3zM0,-6.5h2v0.5h-2zM0,-6h0.5v0.5h-0.5z',
    },
  ],
  pixels: 606,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M3,1h3v0.5h-3zM-6,1.5h2.5v0.5h-2.5zM3.5,1.5h3.5v0.5h-3.5zM-5,2h2.5v0.5h-2.5zM3,2h3v0.5h-3zM2,2.5h1v0.5h-1z',
    },
    {
      paint: 'rock',
      d: 'M0.5,-13h3v0.5h-3zM-3,-12.5h6.5v0.5h-6.5zM-3.5,-12h3v0.5h-3zM-9,-8.5h1v0.5h-1zM8,-8.5h1v0.5h-1zM-8.5,-8h1v0.5h-1zM7.5,-8h1v0.5h-1zM-7,-7.5h1.5v0.5h-1.5zM5.5,-7.5h1.5v0.5h-1.5zM-5.5,-7h1v0.5h-1zM4,-7h1.5v0.5h-1.5zM-4,-6.5h1.5v0.5h-1.5zM2.5,-6.5h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM1,-6h1v0.5h-1zM-0.5,-5.5h1v0.5h-1zM-6,-1.5h1v0.5h-1zM5,-1.5h1v0.5h-1zM-6.5,-1h2.5v0.5h-2.5zM4,-1h2.5v0.5h-2.5zM-5.5,-0.5h2.5v0.5h-2.5zM3,-0.5h3v0.5h-3zM-4.5,0h2.5v0.5h-2.5zM2,0h3v0.5h-3zM-3.5,0.5h2.5v0.5h-2.5zM1.5,0.5h2.5v0.5h-2.5zM-2.5,1h2v0.5h-2zM2.5,1h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'boulder',
      d: 'M-6.5,-0.5h1v0.5h-1zM-6.5,0h2v0.5h-2zM-6,0.5h2.5v0.5h-2.5zM-5,1h2.5v0.5h-2.5zM-3.5,1.5h2v0.5h-2zM3,1.5h0.5v0.5h-0.5zM-2.5,2h2v0.5h-2zM2.5,2h0.5v0.5h-0.5zM-2,2.5h2.5v0.5h-2.5zM-0.5,3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-5,-6h0.5v2h-0.5zM-1,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM-2,-3.5h2v0.5h-2zM0.5,-3.5h1.5v0.5h-1.5zM-5,-3h0.5v2h-0.5zM-3,-3h3v0.5h-3zM0.5,-3h2.5v0.5h-2.5zM-4,-2.5h0.5v2h-0.5zM-2,-2.5h2v0.5h-2zM0.5,-2.5h1.5v0.5h-1.5zM3.5,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM-1,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM2,-2h1v2h-1zM3.5,-2h1v0.5h-1zM-2.5,-1.5h0.5v0.5h-0.5zM3.5,-1.5h1.5v0.5h-1.5zM-3,-1h1v1h-1zM-1,-1h0.5v0.5h-0.5zM0.5,-1h1v1h-1zM3.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h1.5v0.5h-1.5zM-2,0h2v0.5h-2zM0.5,0h1.5v0.5h-1.5zM-1,0.5h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M4,-6h1v2.5h-1zM-0.5,-4.5h1v1h-1zM-5,-4h0.5v0.5h-0.5zM-5,-3.5h1.5v0.5h-1.5zM0,-3.5h0.5v2h-0.5zM3.5,-3.5h1.5v0.5h-1.5zM-4,-3h1v0.5h-1zM3,-3h2v0.5h-2zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM4,-2.5h1v0.5h-1zM-3.5,-2h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM3,-2h0.5v1.5h-0.5zM4.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-2,-1.5h4v0.5h-4zM-3.5,-1h0.5v0.5h-0.5zM-2,-1h1v0.5h-1zM-0.5,-1h1v0.5h-1zM1.5,-1h0.5v1h-0.5zM-2,-0.5h0.5v0.5h-0.5zM0,-0.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4.5,-6h0.5v2.5h-0.5zM-4.5,-3h0.5v1.5h-0.5z',
    },
    {
      paint: 'path',
      d: 'M0.5,1h2v0.5h-2zM-0.5,1.5h3.5v0.5h-3.5zM-0.5,2h3v0.5h-3zM0.5,2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-8.5,-7.5h1.5v0.5h-1.5zM5,-7.5h0.5v0.5h-0.5zM7,-7.5h1.5v0.5h-1.5zM-8,-7h2.5v0.5h-2.5zM5.5,-7h2.5v0.5h-2.5zM-6,-6.5h2v0.5h-2zM4,-6.5h2v0.5h-2zM-4,-6h1.5v0.5h-1.5zM2,-6h2v0.5h-2zM-3,-5.5h2.5v0.5h-2.5zM0.5,-5.5h2.5v0.5h-2.5zM-1,-5h2v0.5h-2z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-0.5,-12h3v0.5h-3zM-3,-11.5h5v1h-5zM-3.5,-10.5h5.5v0.5h-5.5zM-4.5,-10h6v0.5h-6zM-5,-9.5h6.5v0.5h-6.5zM-6,-9h7v0.5h-7zM6,-9h0.5v0.5h-0.5zM-7.5,-8.5h8.5v1h-8.5zM7.5,-8.5h0.5v0.5h-0.5zM7,-8h0.5v0.5h-0.5zM-5.5,-7.5h6v0.5h-6zM-4.5,-7h5v0.5h-5zM3.5,-7h0.5v1h-0.5zM-2.5,-6.5h2.5v0.5h-2.5zM2,-6.5h0.5v0.5h-0.5zM-1,-6h1v0.5h-1zM0.5,-6h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2.5,-12h0.5v0.5h-0.5zM2,-11.5h1.5v0.5h-1.5zM2,-11h2v0.5h-2zM2,-10.5h2.5v0.5h-2.5zM1.5,-10h3.5v0.5h-3.5zM1.5,-9.5h4v0.5h-4zM1,-9h5v0.5h-5zM1,-8.5h6.5v0.5h-6.5zM1,-8h6v0.5h-6zM0.5,-7.5h4.5v0.5h-4.5zM0.5,-7h3v0.5h-3zM0,-6.5h2v0.5h-2zM0,-6h0.5v0.5h-0.5z',
    },
  ],
  pixels: 630,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-5,1h1v0.5h-1zM3,1h3v0.5h-3zM-6,1.5h3v0.5h-3zM3.5,1.5h3.5v0.5h-3.5zM-5,2h2.5v0.5h-2.5zM3,2h3v0.5h-3zM-2,2.5h0.5v0.5h-0.5zM2,2.5h1v0.5h-1z',
    },
    {
      paint: 'rock',
      d: 'M2.5,-14.5h0.5v0.5h-0.5zM-1,-14h4v0.5h-4zM-3,-13.5h4.5v0.5h-4.5zM-3,-13h1v0.5h-1zM-7.5,-8.5h0.5v0.5h-0.5zM6.5,-8.5h1v0.5h-1zM-7.5,-8h1.5v0.5h-1.5zM6,-8h1.5v0.5h-1.5zM-6,-7.5h1v0.5h-1zM5,-7.5h1v0.5h-1zM-4.5,-7h1v0.5h-1zM3.5,-7h1v0.5h-1zM-3.5,-6.5h1.5v0.5h-1.5zM2,-6.5h1v0.5h-1zM-2,-6h1.5v0.5h-1.5zM1,-6h1v0.5h-1zM-0.5,-5.5h1v0.5h-1zM-5.5,-1h1.5v0.5h-1.5zM4,-1h1.5v0.5h-1.5zM-5,-0.5h2v0.5h-2zM3,-0.5h2.5v0.5h-2.5zM-4,0h2v0.5h-2zM2,0h2.5v0.5h-2.5zM-3,0.5h2v0.5h-2zM1.5,0.5h2v0.5h-2zM-2.5,1h2v0.5h-2zM2.5,1h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'boulder',
      d: 'M-6,-1h0.5v0.5h-0.5zM-6,-0.5h1v0.5h-1zM-6,0h2v0.5h-2zM-5,0.5h2v0.5h-2zM-4,1h1.5v0.5h-1.5zM-3,1.5h1.5v0.5h-1.5zM3,1.5h0.5v0.5h-0.5zM-2.5,2h2v0.5h-2zM2.5,2h0.5v0.5h-0.5zM-1.5,2.5h2v0.5h-2zM-0.5,3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-5,-6h0.5v2h-0.5zM-1,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM-2,-3.5h2v0.5h-2zM0.5,-3.5h1.5v0.5h-1.5zM-5,-3h0.5v2h-0.5zM-3,-3h3v0.5h-3zM0.5,-3h2.5v0.5h-2.5zM-4,-2.5h0.5v2h-0.5zM-2,-2.5h2v0.5h-2zM0.5,-2.5h1.5v0.5h-1.5zM3.5,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM-1,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM2,-2h1v2h-1zM3.5,-2h1v0.5h-1zM-2.5,-1.5h0.5v0.5h-0.5zM3.5,-1.5h1.5v0.5h-1.5zM-3,-1h1v1h-1zM-1,-1h0.5v0.5h-0.5zM0.5,-1h1v1h-1zM3.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h1.5v0.5h-1.5zM-2,0h2v0.5h-2zM0.5,0h1.5v0.5h-1.5zM-1,0.5h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M4,-6h1v2.5h-1zM-0.5,-4.5h1v1h-1zM-5,-4h0.5v0.5h-0.5zM-5,-3.5h1.5v0.5h-1.5zM0,-3.5h0.5v2h-0.5zM3.5,-3.5h1.5v0.5h-1.5zM-4,-3h1v0.5h-1zM3,-3h2v0.5h-2zM-3.5,-2.5h1.5v0.5h-1.5zM2,-2.5h1.5v0.5h-1.5zM4,-2.5h1v0.5h-1zM-3.5,-2h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM3,-2h0.5v1.5h-0.5zM4.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h0.5v0.5h-0.5zM-3.5,-1.5h1v0.5h-1zM-2,-1.5h4v0.5h-4zM-3.5,-1h0.5v0.5h-0.5zM-2,-1h1v0.5h-1zM-0.5,-1h1v0.5h-1zM1.5,-1h0.5v1h-0.5zM-2,-0.5h0.5v0.5h-0.5zM0,-0.5h0.5v1.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4.5,-6h0.5v2.5h-0.5zM-4.5,-3h0.5v1.5h-0.5z',
    },
    {
      paint: 'path',
      d: 'M0.5,1h2v0.5h-2zM-0.5,1.5h3.5v0.5h-3.5zM-0.5,2h3v0.5h-3zM0.5,2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['giwa', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-3,-12h0.5v0.5h-0.5zM-7.5,-7.5h1.5v0.5h-1.5zM6,-7.5h1.5v0.5h-1.5zM-6.5,-7h1.5v0.5h-1.5zM4.5,-7h2v0.5h-2zM-5,-6.5h1.5v0.5h-1.5zM3,-6.5h2v0.5h-2zM-4,-6h2v0.5h-2zM2,-6h2v0.5h-2zM-2.5,-5.5h2v0.5h-2zM0.5,-5.5h2v0.5h-2zM-1,-5h2v0.5h-2z',
    },
    {
      paint: [
        ['giwa', 0.73],
        ['sail', 0.27],
      ],
      d: 'M1.5,-13.5h1v0.5h-1zM-2,-13h4v0.5h-4zM-2.5,-12.5h4.5v0.5h-4.5zM-2.5,-12h4v1h-4zM-3,-11h4.5v0.5h-4.5zM-4,-10.5h5.5v0.5h-5.5zM-4,-10h5v0.5h-5zM-4.5,-9.5h5.5v0.5h-5.5zM-5.5,-9h1v0.5h-1zM-4,-9h5v0.5h-5zM-6.5,-8.5h7.5v0.5h-7.5zM-6,-8h6.5v0.5h-6.5zM-5,-7.5h5.5v0.5h-5.5zM4.5,-7.5h0.5v0.5h-0.5zM-5,-7h0.5v0.5h-0.5zM-3.5,-7h3.5v0.5h-3.5zM3,-7h0.5v0.5h-0.5zM-2,-6.5h2v0.5h-2zM-0.5,-6h0.5v0.5h-0.5zM0.5,-6h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'giwa',
      d: 'M2,-13h0.5v0.5h-0.5zM2,-12.5h1v0.5h-1zM1.5,-12h1.5v0.5h-1.5zM-3,-11.5h0.5v0.5h-0.5zM1.5,-11.5h2v0.5h-2zM-3.5,-11h0.5v0.5h-0.5zM1.5,-11h2.5v1h-2.5zM1,-10h3.5v0.5h-3.5zM1,-9.5h4v0.5h-4zM-4.5,-9h0.5v0.5h-0.5zM1,-9h4.5v0.5h-4.5zM1,-8.5h5.5v0.5h-5.5zM0.5,-8h5.5v0.5h-5.5zM0.5,-7.5h4v0.5h-4zM0,-7h3v0.5h-3zM0,-6.5h2v0.5h-2zM0,-6h0.5v0.5h-0.5z',
    },
  ],
  pixels: 606,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
